export const PAGE_NUMBERS = 10;
export const UNLIMITED_PAGE_SIZE = 999999999;

export const tossPaymentInit = {
  VAN_TRANTYPE: 'S0',
  LGD_TXNAME: 'CardAuthOfflinePos',
  LGD_REQTYPE: 'APPR',
  LGD_PAYTYPE: 'SC0100',
  LGD_TAXFREEAMOUNT: '0',
  VAN_SFEEAMOUNT: '0',
  LGD_BUYER: '..',
};

export const campusHeadOffice = 'CB00000001';

export const studentPaymentTableLabels = [
  '금액',
  '할인 금액',
  '결제금액',
  '할부',
  '상태',
] as const;

//export const financialsDefAppMemCode = 'CB00004149';

export const financialsDefCCMemCode = 'CB00019479';